import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';
import { DATA } from '@/plugins/vuex-async-pagginate';

class TrunkServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  getSelect(params) {
    return super.getList(params).then(res => res[DATA]);
  }
}

export const TrunkService = new TrunkServiceClass({
  api_version: 2,
  resource: 'voice/trunks'
});
